import { Airport } from '../filters/useLocations';
import { IMCFare as Fare } from '../types';

type MarkerType = 'origin' | 'destination' | 'noFare' | 'fare';

export interface MarkerData extends Airport {
  name?: string;
  markerType?: MarkerType;
  fare?: any;
}

export type OriginMarkerData = MarkerData;

export interface DestinationMarkerData extends MarkerData {
  loading: boolean;
}

export interface NoFareMarkerData extends DestinationMarkerData {
  origin: Airport;
  journeyType: string;
}

export interface FareMarkerData extends DestinationMarkerData {
  minimized: boolean;
  order: number;
  fare: Fare;
}

export function createOriginMarker(airport: Airport): MarkerData {
  return {
    ...airport,
    markerType: 'origin'
  };
}

export function createDestinationMarker(airport: Airport): DestinationMarkerData {
  return {
    ...airport,
    markerType: 'destination',
    loading: false
  };
}

export function createNoFareMarker(marker: Airport, origin: Airport): NoFareMarkerData {
  return {
    ...marker,
    markerType: 'noFare',
    loading: false,
    origin,
    journeyType: 'ROUND_TRIP'
  };
}

export function createFareMarker(marker: Airport, fare: Fare): FareMarkerData {
  return {
    ...marker,
    markerType: 'fare',
    loading: false,
    minimized: false,
    order: -1,
    fare
  };
}

export function isFareMarker(marker: MarkerData): marker is FareMarkerData {
  return marker.markerType === 'fare';
}

export function isNoFareMarker(marker: MarkerData): marker is NoFareMarkerData {
  return marker.markerType === 'noFare';
}
